// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Io5z","right":"styles_right__3vjYH"};